const FEATURE_FLAGS_TABLE_HEADERS = [
  { name: 'Name', column: 'name' },
  { name: 'Key', column: 'key' },
  { name: 'Description', column: 'description' },
  { name: 'Current State', column: 'current_state_badge' },
  { name: 'Default State', column: 'default_state_formatted' },
  { name: 'Updated At', column: 'updated_at_formatted' }
];

const FEATURE_FLAG_OVERRIDES_TABLE_HEADERS = [
  { name: 'Merchant', column: 'merchant_name' },
  { name: 'Email', column: 'merchant_email' },
  { name: 'Feature Name', column: 'feature_name' },
  { name: 'Feature Key', column: 'feature_key' },
  { name: 'Override State', column: 'override_state_badge' },
  { name: 'Reason', column: 'reason' },
  { name: 'Updated At', column: 'updated_at_formatted' }
];

export { FEATURE_FLAGS_TABLE_HEADERS, FEATURE_FLAG_OVERRIDES_TABLE_HEADERS };
